export const ASYNC_RESOURCE_RELOAD_KEY = 'nexo:async-resource-reload';

const ROUTER_RELOAD_KEY_PREFIX = 'tanstack_router_reload:';

const ASYNC_RESOURCE_ERROR_MESSAGES = [
  /loading (?:css )?chunk .+ failed/i,
  /failed to (?:fetch dynamically imported module|load (?:async resource|module script))/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
];

export const canReloadAsyncResource = (error: unknown): boolean => {
  if (!(error instanceof Error)) {
    return false;
  }

  const isResourceError =
    error.name === 'ChunkLoadError' ||
    ASYNC_RESOURCE_ERROR_MESSAGES.some((pattern) =>
      pattern.test(error.message),
    );

  if (!isResourceError) {
    return false;
  }

  try {
    // TanStack already reloads certain module errors. Respect that attempt too.
    return (
      sessionStorage.getItem(ASYNC_RESOURCE_RELOAD_KEY) === null &&
      sessionStorage.getItem(`${ROUTER_RELOAD_KEY_PREFIX}${error.message}`) ===
        null
    );
  } catch {
    return false;
  }
};
